import React from 'react';
import { useTranslation } from 'react-i18next';
import { securityFeatures } from '../data/mock';
import { Shield, Key, Lock, Users, MessageCircle, Activity, ExternalLink } from 'lucide-react';

const iconMap = {
  shield: Shield,
  key: Key,
  lock: Lock,
  users: Users,
  'message-circle': MessageCircle,
  activity: Activity,
};

const Security = () => {
  const { t } = useTranslation('landing');
  return (
    <section className="py-24 bg-gradient-to-b from-[#0a0a0b] to-[#0f0f12]">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t('security.headline_a')}<br />{t('security.headline_b')}
          </h2>
          {/* /security is an English-only page with one address (no /de/security): a plain link. */}
          <a
            href="/security"
            className="inline-flex items-center gap-2 text-amber-400 hover:text-amber-300 transition-colors"
          >
            {t('security.learn_link')}
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {securityFeatures.map((feature) => {
            const Icon = iconMap[feature.icon] || Shield;
            return (
              <a
                key={feature.key}
                href="/security"
                className="p-6 bg-white/5 rounded-2xl border border-gray-800 hover:border-amber-500/30 transition-all duration-300 group block"
              >
                <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-amber-500/20 to-orange-500/20 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                  <Icon className="w-6 h-6 text-amber-400" />
                </div>
                <h3 className="text-white font-semibold text-lg mb-2 group-hover:text-amber-400 transition-colors">{t(`security.items.${feature.key}.title`)}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{t(`security.items.${feature.key}.desc`)}</p>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Security;
